import { useQuery } from '@tanstack/react-query';
import Packlink from '@sdk';
import { Currency, IShipment, Shipment } from '@packlink/packlink-sdk';
import { normalizeShipmentInsurance } from '@utils/ShipmentUtils';

type BulkInsuranceBasePriceResult = {
    insurancePrice: number;
    insurancePriceFormat: string;
    isLoadingInsurancePrice: boolean;
};

export function useBulkInsuranceBasePrice(shipments: Shipment<IShipment>[]): BulkInsuranceBasePriceResult {
    const normalizedShipments = shipments.map((shipment) => normalizeShipmentInsurance(shipment, true));

    const query = useQuery({
        // eslint-disable-next-line @tanstack/query/exhaustive-deps
        queryKey: ['bulkInsurancePrice'],
        queryFn: () => Packlink.pro.shipments.products.get(normalizedShipments),
    });

    const insurancePrice = query?.data?.summary?.products?.insurance?.basePrice ?? 0;
    return {
        insurancePrice,
        insurancePriceFormat:
            Currency.format(insurancePrice, query?.data?.summary?.products?.insurance?.currency) ?? '',
        isLoadingInsurancePrice: query.isLoading,
    };
}
